import React from 'react'
import { useTranslation } from "react-i18next";

import Phone from "../../../assets/search/phone.svg";
import location from "../../../assets/search/location.svg";
import profile_icon from "../../../assets/images/userexpert.svg";
import messageme from "../../../assets/images/messageme.svg";
import unverifiedinfo from "../../../assets/search/unverifiedinfo.svg";

import email from "../../../assets/search/email.svg";
import { NEW_URL } from '../../../constants/applicationConstants';
import styles from './expertListCard.module.css';
import { Link } from "react-router-dom";
import { mixPannelEvent } from '../../../shared/helper';

export const ExpertListCardJSX = (props) => {

  const { t } = useTranslation();

  const {
    offerimageUrl, offerbusinessPhoneNumber, offercity, offeremail, offerfirstName, offerslugUrl,
    expertSpecializations, offerplanName, status, offerlastName, offercategoryName,
    onFirstLoginClick, isResumeShowAndContactHide, isparentInstitutionCategory,offer
  } = props;
  const trackMixArticle =() =>{
    mixPannelEvent({
      eventName: "expert_profile_viewed",
      data: {
        id: offer.expertId
      }
    })
  }
  return (
    <>
      {offercategoryName &&
        <div  onClick={trackMixArticle()} className={`${styles.institutesearchmainlistingsectionps} ${offerplanName}  ${offercategoryName} status${status}`}>

          <div className={styles.instilogoouter}>

            {props?.showFreeTag &&
              <div className={`free-tag ${props?.addedAsFree && 'is-free'}`}>
                {props?.addedAsFree ? 'Free' : 'Paid'}
              </div>
            }


            <div className={`${styles.instilogo} statuslogo `}>
              {status === "unverified" || status === "verified" ?
                <div className={`${styles.instilogoimage} imageborder status`}>{status}</div>
                :
                <Link to={`/expertPpv/${offerslugUrl}`} target="_blank">
                  <div className={`${styles.instilogoimage} imageborder`}><img src={!offerimageUrl
                    ? `https://ui-avatars.com/api/?name=${offerfirstName}+${offerlastName}&rounded=true`
                    : `${NEW_URL}/${offerimageUrl}`} alt={`${offerfirstName}`}
                  /></div>
                </Link>
              }

            </div>
            {status === "unverified" || status === "verified" ?
              null :
              <div className={`${styles.plainde} expertoutershadow ${offerplanName}`}>{offerplanName || "NA"}</div>}
          </div>
          <div className={`${styles.instisegricateouter} d-flex`}>
            
            <div className={styles.instisegricateone}>
              <h4>{offerfirstName.toLowerCase() + " " + offerlastName.toLowerCase()}</h4>
              <div className={`${styles.instisegricatetwo} instisegricatetwops d-block d-lg-none d-sm-none d-md-none `}>

                <ul>
                  {
                    isparentInstitutionCategory ? expertSpecializations.map((data, index) => {
                      return (
                        <li key={index} className={data.parentInstitutionCategory}>
                          {data.parentInstitutionCategory}
                        </li>
                      );
                    }) : expertSpecializations?.map(cat => cat.categoryName).map((categoryName, index) => {
                      return (
                        <li key={index} className={categoryName}>
                          {categoryName}
                        </li>
                      );
                    })
                  }

                </ul>
              </div>
              {isResumeShowAndContactHide && <button className={`${styles.resumebutton}`} onClick={onFirstLoginClick}>{t("instituteExpertrs.RESUME")}</button>}
              <div className={styles.condetails}>
                <ul>
                  {offercity && <li><span><img src={location} alt={offerfirstName + " " + offerlastName} className="imagefilter" /></span> {offercity}</li>}
                  {offerbusinessPhoneNumber && <li><span><img src={Phone} alt={offerfirstName + " " + offerlastName} className="imagefilter" /></span><a href="tel:416262-5457">{offerbusinessPhoneNumber}</a> </li>}
                  {email && <li><span><img src={email} alt={offerfirstName + " " + offerlastName} className="imagefilter" /></span> <a href="mailto:samar@indexrealtybrokerage.com">{offer?.contactEmail || offeremail}</a></li>}
                </ul>

              </div>
              {status === "unverified" || status === "verified" ?
                null : <div className={`${styles.basicdetails} d-flex`}>
                  {offerplanName === "Premium" ?
                    null :
                    !isResumeShowAndContactHide && <Link to={`/expertPpv/${offerslugUrl}#contact`} target="_blank" className={`${styles.bdetail} bdeatailglobal`}><span><img src={messageme} alt="profile Icon" /></span>{t("COMMON.MESSAGEME")}</Link>}
                  {!isResumeShowAndContactHide && <Link to={`/expertPpv/${offerslugUrl}`} target="_blank" className={`${styles.bdetail} bdeatailglobal`}><span><img src={profile_icon} alt="profile Icon" /></span>{t("COMMON.VIEWPROFILE")}</Link>}
                </div>
              }
              {status === "unverified" &&
                <span className="unverifiedinfo"><img src={unverifiedinfo} alt="icon" /> {t("COMMON.UNVERIFIEDINFO")}</span>
              }
            </div>

            <div className={`${styles.instisegricatetwo} instisegricatetwops d-none d-sm-block`}>

              <ul>
                {
                  isparentInstitutionCategory ? expertSpecializations.map((data, index) => {
                    return (
                      <li key={index} className={data.parentInstitutionCategory}>
                        {data.parentInstitutionCategory}
                      </li>
                    );
                  }) : expertSpecializations?.map(cat => cat.categoryName).map((categoryName, index) => {
                    return (
                      <li key={index} className={categoryName}>
                        {categoryName}
                      </li>
                    );
                  })
                }

              </ul>
            </div>
          </div>
        </div>
      }
    </>
  )
}
